import { AnyAction } from '@reduxjs/toolkit';
import { CHANGE_STEP } from '../action-types';
import type { IChangeStepAction } from '../actions';
import type { IStepsState } from '../interfaces';

export const initialState: IStepsState = {
  currentStep: 0,
};

export const stepsReducer = (
  state: IStepsState = initialState,
  action: AnyAction,
): IStepsState => {
  switch (action.type) {
    case CHANGE_STEP:
      return {
        ...state,
        currentStep: (action as IChangeStepAction).payload,
      };

    default:
      return state;
  }
};
